const EnumFileType = {
  MANUSCRIPT: [".doc", ".docx", ".odt"],
  ADDITIONAL: [".doc", ".docx", ".odt", ".pdf"],
  FIGURE: [".png", ".jpg", ".tiff", ".TIFF"],
  VIDEO: [".mp4", ".flv", ".webm", ".ogv", ".3gp", ".avi"],
};

export default EnumFileType;
